import { resolveUnref } from '@vueuse/core'
import { computed } from 'vue'

export function useVirtualGameOdds (odds, teams) {
  const oddsNames = {
    '1': teams[0]?.name,
    '2': teams[1]?.name,
    '3': teams[2]?.name,
    '4': teams[3]?.name,
    '5': teams[4]?.name,
    '6': teams[5]?.name,
    'X': '무승부',
    'OVER': '오버',
    'UNDER': '언더',
    'YES': '예',
    'NO': '아니오',
    '1X': '1팀승/무승부',
    '12': '1팀승/2팀승',
    'X2': '2팀승/무승부',
  }

  function getName (name) {
    return oddsNames[name?.toUpperCase()]
  }

  function getValue (value) {
    return Number(value).toFixed(2)
  }

  const name = computed(() => {
    const resolved = resolveUnref(odds)

    return getName(resolved.n)
  })

  const value = computed(() => {
    const resolved = resolveUnref(odds)

    return getValue(resolved.v)
  })

  return {
    name,
    value,
  }
}
